/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import IcomoonReact from 'icomoon-react';
import ResizeObserver from 'react-resize-observer';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../shared/GlobalStyles';
import Text from '../../../shared/components/Text/Text';
import generateUniqueId from '../../../shared/utils/generateUniqueId';
import { setNewPreSaveItemFromCreateExerciseForm, addPreSavedItemToCalendarItemsArray, addPreSavedItemToProgramItemsArray } from '../ducks/calendarActions';

const ModalContainer = styled('div')`
    .remove-div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      background: ${({ theme }) => theme.colors.surface};
      z-index: 1001;
      .remove-div-icon {
        cursor: pointer;
        transition: ${TransitionGlobal};
        :hover {
          opacity: 0.7;
        }
      }
    }
  height: 100%;
  position: relative;
`;

const ModalTextTop = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
   @media (max-width: 370px) {
    font-size: 22px;
  }
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${({ theme }) => theme.colors.text};
  color: ${({ theme }) => theme.colors.surface};
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${({ theme }) => theme.colors.text};
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover { 
    opacity: 0.7; 
  }
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 2px solid ${({ theme }) => theme.colors.text};
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover { 
    opacity: 0.7; 
  }
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExercisesContainer = styled('div')`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-direction: column;
  min-height: 100px;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ExerciseItem = styled('div')`
  display: flex;
  gap: 5px;
`;

const TagAssociatedExercisesModal = ({
  closeModal,
}) => {
  const dispatch = useDispatch();
  const [containerWidth, setContainerWidth] = useState(0);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const tagData = useSelector((state) => state.calendar.data.modalData);
  const tagDataExercises = tagData?.exercises;
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const date = new Date(selectedDate);
  const endpointFormattedDate = moment(date).format('YYYY-MM-DD');

  const handleAddtoWorkout = () => {
    const newItem = {
      icon: 'tag2',
      title: tagData.name,
      exerciseId: parseInt(tagData.id, 10),
      id: `${tagData.id}-${generateUniqueId()}`,
      assignedId: `${tagData.id}-${generateUniqueId()}`,
      preSave: true,
      type: 'T',
    };
    dispatch(setNewPreSaveItemFromCreateExerciseForm(newItem));
    /** set redux call to add pre saved item to calendar items array in redux */
    if (programType === 'free-form-program') {
      dispatch(addPreSavedItemToProgramItemsArray(newItem, selectedProgramDayNumber));
    } else {
      dispatch(addPreSavedItemToCalendarItemsArray(newItem, endpointFormattedDate));
    }
    closeModal();
  };

  const { colors } = useTheme();
  return (
    <ModalContainer>
      <ResizeObserver
        onResize={(rect) => {
          setContainerWidth(rect?.width);
        }}
      />
      <div className='remove-div'>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <ModalTextTop style={{
            maxWidth: `${containerWidth}px`, wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal',
          }}
          >
            {tagData?.name}
          </ModalTextTop>
        </div>
        <div
          className='remove-div-icon'
          onClick={() => closeModal()}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={15}
            icon='remove'
            color={colors.textSecondary}
          />
        </div>
      </div>
      <Text fontWeight={700} fontSize='16px'>
        Associated Exercises (
        {tagDataExercises?.length}
        )
      </Text>
      <Text fontSize='13px' fontWeight={400} color={colors.textSecondary} style={{ marginBottom: '12px' }}>
        The exercises below are associated with this Tag. Athletes will be able to choose from the exercises below when this Tag is programmed or assigned to them.
      </Text>
      <ExercisesContainer>
        {tagDataExercises?.map((exercise, index) => (
          <ExerciseItem>
            <Text fontSize='16px'>
              {index + 1}
              .
            </Text>
            <Text style={{
              maxWidth: `${containerWidth}px`, wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal',
            }}
            >
              {exercise?.name}
            </Text>
          </ExerciseItem>
        ))}
      </ExercisesContainer>
      <ButtonsContainer>
        <SaveButton onClick={handleAddtoWorkout}>
          <Text color={colors.surface} fontSize='16px' fontWeight={700}>ADD TO WORKOUT</Text>
        </SaveButton>
        <CancelButton onClick={() => closeModal()}>
          <Text fontSize='16px' fontWeight={700}>CLOSE</Text>
        </CancelButton>
      </ButtonsContainer>
    </ModalContainer>
  );
};

TagAssociatedExercisesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default TagAssociatedExercisesModal;
